import { render, staticRenderFns } from "./SlimeBlock.vue?vue&type=template&id=6f0f0def&scoped=true"
import script from "./SlimeBlock.vue?vue&type=script&lang=js"
export * from "./SlimeBlock.vue?vue&type=script&lang=js"
import style0 from "./SlimeBlock.vue?vue&type=style&index=0&id=6f0f0def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f0def",
  null
  
)

export default component.exports